import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Per-page SEO: sets <title>, meta description, og:title, og:description, og:url, canonical
// Usage in a page:
//   useSeo({ title: "Foundation for Change — Stories by Aradhana", description: "..." })
export default function useSeo({ title, description, path }) {
  const { pathname } = useLocation();
  const resolvedPath = path || pathname;
  const origin = "https://storiesbyaradhana.com";
  const fullUrl = `${origin}${resolvedPath}`;

  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (selector, create) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = create();
        document.head.appendChild(el);
      }
      return el;
    };

    if (description) {
      const metaDesc = setMeta('meta[name="description"]', () => {
        const m = document.createElement("meta");
        m.setAttribute("name", "description");
        return m;
      });
      metaDesc.setAttribute("content", description);

      const ogDesc = setMeta('meta[property="og:description"]', () => {
        const m = document.createElement("meta");
        m.setAttribute("property", "og:description");
        return m;
      });
      ogDesc.setAttribute("content", description);

      const twDesc = setMeta('meta[name="twitter:description"]', () => {
        const m = document.createElement("meta");
        m.setAttribute("name", "twitter:description");
        return m;
      });
      twDesc.setAttribute("content", description);
    }

    if (title) {
      const ogTitle = setMeta('meta[property="og:title"]', () => {
        const m = document.createElement("meta");
        m.setAttribute("property", "og:title");
        return m;
      });
      ogTitle.setAttribute("content", title);

      const twTitle = setMeta('meta[name="twitter:title"]', () => {
        const m = document.createElement("meta");
        m.setAttribute("name", "twitter:title");
        return m;
      });
      twTitle.setAttribute("content", title);
    }

    const ogUrl = setMeta('meta[property="og:url"]', () => {
      const m = document.createElement("meta");
      m.setAttribute("property", "og:url");
      return m;
    });
    ogUrl.setAttribute("content", fullUrl);

    const canonical = setMeta('link[rel="canonical"]', () => {
      const l = document.createElement("link");
      l.setAttribute("rel", "canonical");
      return l;
    });
    canonical.setAttribute("href", fullUrl);
  }, [title, description, fullUrl]);
}
